import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";
import Logo from "@/components/layout/Logo";
import { CLINIC } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-foreground text-background mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-4">
            <Logo className="h-16 w-16" />
            <div className="font-serif text-3xl">Manasvi Dental Clinic</div>
          </div>
          <p className="text-background/70 max-w-md">Premium dental care in Kota led by Dr. Deepika Charan. Warm, modern, and pain-free treatments for the entire family.</p>
          <div className="flex items-center gap-4 mt-6">
            <a href="#" className="w-9 h-9 rounded-full border border-background/20 grid place-items-center hover:bg-background/10" data-testid="social-instagram"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-background/20 grid place-items-center hover:bg-background/10" data-testid="social-facebook"><Facebook className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <div className="text-sm tracking-widest uppercase text-background/60 mb-4">Explore</div>
          <ul className="space-y-2 text-background/80">
            <li><Link to="/about" data-testid="footer-link-about">About Us</Link></li>
            <li><Link to="/doctor" data-testid="footer-link-doctor">Dr. Deepika</Link></li>
            <li><Link to="/services" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/gallery" data-testid="footer-link-gallery">Gallery</Link></li>
            <li><Link to="/reviews" data-testid="footer-link-reviews">Reviews</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            <li><Link to="/book" data-testid="footer-link-book">Book Appointment</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm tracking-widest uppercase text-background/60 mb-4">Reach Us</div>
          <ul className="space-y-3 text-background/80 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-1 shrink-0" /> {CLINIC.address}</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-1" /> {CLINIC.phone}</li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-1" /> {CLINIC.email}</li>
            <li className="flex gap-3"><Clock className="w-4 h-4 mt-1" /> {CLINIC.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background/10 py-5 text-center text-background/50 text-xs">
        © {new Date().getFullYear()} Manasvi Dental Clinic • Designed with care in Kota
      </div>
    </footer>
  );
}
